import React from 'react';
import PropType from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { FlexColumn } from 'ui-components/components/flex';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import ModalPortal from '../../../../components/modal-portal';
import EditItemHeader from './edit-items-header';

import EditItemsSection from './edit-items-section/edit-items-section';
import ErrorBanner from './error-banner';
import EditItemsContextProvider from './context';
import Footer from './footer/footer';
import useEditItemsData from './use-edit-items-data';

import messages from './messages';
import style from './style.module.less';

const EditItemsModal = ({ onClose, fulfillmentPlanId, salesOrderId }) => {
  const { items } = useEditItemsData(fulfillmentPlanId);

  return (
    <EditItemsContextProvider fulfillmentPlanId={fulfillmentPlanId} items={items} onSuccess={onClose} salesOrderId={salesOrderId}>
      <ModalPortal onClose={onClose}>
        <Modal className={style.modal} size='custom'>
          <ModalHeader>
            <FormattedMessage {...messages.editItemModalHeader} />
          </ModalHeader>
          <ModalBody className={style['modal-body']}>
            <FlexColumn className={style['content-wrapper']}>
              <ErrorBanner />
              <EditItemHeader fulfillmentPlanId={fulfillmentPlanId} salesOrderId={salesOrderId} />
              <EditItemsSection fulfillmentPlanId={fulfillmentPlanId} salesOrderId={salesOrderId} />
            </FlexColumn>
          </ModalBody>
          <Footer />
        </Modal>
      </ModalPortal>
    </EditItemsContextProvider>
  );
};

EditItemsModal.propTypes = {
  fulfillmentPlanId: PropType.string.isRequired,
  salesOrderId: PropType.string.isRequired,
  onClose: PropType.func.isRequired,
};

export { EditItemsModal };
